export const EstimatesActionTypes = {
    API_RESPONSE_SUCCESS: '@@estimates/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@estimates/API_RESPONSE_ERROR',

    CREATE_ESTIMATE: '@@estimates/CREATE_ESTIMATE',
    LIST_ESTIMATES_BY_CLIENT: '@@estimates/LIST_ESTIMATES_BY_CLIENT',

    RESET: '@@estimates/RESET',
};
